export default __webpack_public_path__ + "static/media/panel.88f02e93.svg";